const tr = {
    common: {
        history: "tarihi versiyon"
    }
};
export default tr;



// WEBPACK FOOTER //
// ./src/i18n/langs/tr.js